<template>
  <div class="message-banner"
       :class="customClass">
    <slot>{{ message }}</slot>
  </div>
</template>

<script>
export default {
  name: "MessageBanner",
  props: {
    customClass: {
      type: String,
      default: null,
    },
    /**
     * Should not contain HTML, that can only be rendered via the default slot
     */
    message: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="less">
@import "../../Styles/utils/colors";

.message-banner {
  border: 1px solid @color-primary;
  border-radius: 5px;
  background-color: #F5EEF6;
  padding: 20px;
  margin-bottom: 1rem;

  p:last-child {
    margin-bottom: 0;
  }
}
</style>
